import { CheckImageIsFile, CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { GetFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";
import { PostFunction } from "src/utils/axios_connection";

export const GetMediaList =
  ({ callback, rowsPerPage, page, search }) =>
  async (dispatch, getState) => {
    try {
      const query = search
        ? `?search=${search}&limit=${1000}&page=${0}`
        : `?page=${page}&limit=${rowsPerPage}`;

      let link = UrlApi.media_list.get + query;
      const response = await GetFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const GetMediaTypes =
  ({ callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.media_types.get;
      const response = await GetFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const DeleteMediaList =
  ({ mediaListId, callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.media_list.delete;
      const response = await GetFunction({
        data: {},
        Route: link + `/${mediaListId}`,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageMediaList =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      var bodyFormData = new FormData();
      let paramID = "";
      if (editMode) {
        paramID = values?.id;
      }
      if (CheckDataIfExit(values?.title)) {
        bodyFormData.append("title", values?.title?.trim());
      }
      if (CheckDataIfExit(values?.ref_link)) {
        bodyFormData.append("ref_link", values?.ref_link?.toString());
      }
      // if (CheckDataIfExit(values?.vid)) {
      //   bodyFormData.append("vid");
      // }
      if (CheckDataIfExit(values?.date)) {
        bodyFormData.append("date", values?.date?.toString());
      }
      if (CheckDataIfExit(values?.short_desc)) {
        bodyFormData.append("short_desc", values?.short_desc?.trim());
      }
      if (CheckDataIfExit(values?.full_desc)) {
        bodyFormData.append("full_desc", values?.full_desc?.trim());
      }
      if (values?.media_type_id) {
        bodyFormData.append("media_type_id", values?.media_type_id);
      }
      if (
        values?.image &&
        values?.image != null &&
        values?.image != undefined &&
        CheckImageIsFile({ data: values?.image, IsBoolean: true })
      ) {
        bodyFormData.append("image", values?.image);
      } else if (editMode && !values?.image) {
        bodyFormData.append("image", "");
        bodyFormData.append("remove_image", "1");
      }
      if (
        values?.vid &&
        values?.vid != null &&
        values?.vid != undefined &&
        CheckImageIsFile({ data: values?.vid, IsBoolean: true })
      ) {
        bodyFormData.append("vid", values?.vid);
      } else if (editMode && !values?.vid) {
        bodyFormData.append("vid", "");
        bodyFormData.append("remove_vid", "1");
      }
      // if (
      //   values?.ref_link &&
      //   values?.ref_link != null &&
      //   values?.ref_link != undefined &&
      //   CheckImageIsFile({ data: values?.ref_link, IsBoolean: true })
      // ) {
      //   bodyFormData.append("ref_link", values?.ref_link);
      // } else if (editMode && !values?.ref_link) {
      //   bodyFormData.append("ref_link", "");
      // }
      console.log({ bodyFormDatabodyFormData: bodyFormData });
      const response = await PostFunction({
        data: bodyFormData,
        Route: editMode
          ? `${UrlApi.media_list.edit}/${paramID}`
          : UrlApi.media_list.add,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
        usersRoute: true,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      console.error(err);
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditMediaList =
  ({ callback, allData, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data;
      if (allData) {
        data = allData;
      } else {
        data = {
          [nameFailed]: dataFailed,
        };
      }
      const response = await PostFunction({
        data,
        Route: UrlApi.media_list.edit + `/${id}`,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
        usersRoute: true,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };
